/** Sentry feature tag for errors surfaced inside this module. */
export const LOCATION_FEATURE_TAG = 'location';

/** The query key for the get single location API. */
export const LOCATION_QUERY_KEY = 'location';

/** Location data freshness is managed by the $id route loader — cache is valid until the user navigates away. */
export const LOCATION_STALE_TIME = Infinity;

/**
 * The query key for the locations list API. All Locations and the sidebar location switcher share
 * it, so invalidating it after a change refreshes both.
 */
export const LOCATIONS_QUERY_KEY = 'locations';

/** The largest page the locations list API returns — `num_per_page` accepts 1–15. */
export const LOCATIONS_LIST_MAX_PAGE_SIZE = 15;

/** localStorage key (before the app prefix) for the sidebar switcher's recently opened locations. */
export const RECENT_LOCATIONS_STORAGE_KEY = 'recent_locations';

/** How many recently opened locations the sidebar switcher keeps per user. */
export const RECENT_LOCATIONS_LIMIT = 5;

/** UI-facing kinds of a failed single-location request, keyed off the HTTP status. */
export const LOCATION_ERROR_TYPES = {
  FORBIDDEN: 'forbidden',
  NOT_FOUND: 'notFound',
  UNKNOWN: 'unknown'
} as const;

/**
 * GTM `eventAction` on the Locations Hub / Add Location events — where the user opened a location,
 * searched, or picked Add location: the hub's card grid or table, or the sidebar location switcher.
 */
export const LOCATIONS_TRACKING_SURFACE = {
  CARD: 'card',
  TABLE: 'table',
  SIDEBAR: 'sidebar'
} as const;

/** Union of the surfaces a Locations Hub / Add Location event can fire from. */
export type LocationsTrackingSurface = (typeof LOCATIONS_TRACKING_SURFACE)[keyof typeof LOCATIONS_TRACKING_SURFACE];
